import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { FiltersState } from '../types';

interface FilterStore {
  filters: FiltersState;
  setFilter: (key: keyof FiltersState, value: string | string[] | undefined) => void;
  clearFilters: () => void;
}

/**
 * The ONE scope store every surface reads (drill continuity: "drilling down
 * never starts you over"). Persisted to sessionStorage so a mid-investigation
 * browser refresh keeps the scope — per-tab and gone when the tab closes.
 * Tenancy hygiene: useAuthStore clears it on logout AND on org switch, so a
 * persisted scope can never leak ids across users or organizations.
 */
export const useFilterStore = create<FilterStore>()(persist(
  (set) => ({
    filters: {},
    setFilter: (key, value) =>
      set((state) => ({ filters: { ...state.filters, [key]: value } })),
    clearFilters: () => set({ filters: {} }),
  }),
  { name: 'avium-filters', storage: createJSONStorage(() => sessionStorage) },
));
